export default __webpack_public_path__ + "static/media/objet1.7dc3f069.jpg";